/* NavLink active/hover states have no Radix Themes component — themed via
   Radix's own CSS variables so they stay in lockstep with the theme tokens
   set once in @cmaas/ui's <PortalTheme>. */
.navList {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.navLink,
.navLinkActive {
  display: block;
  padding: var(--space-2);
  border-radius: var(--radius-2);
  text-decoration: none;
  color: var(--gray-12);
  font-size: var(--font-size-2);
}

.navLink:hover {
  background: var(--gray-a3);
}

.navLinkActive {
  background: var(--accent-a4);
  color: var(--accent-12);
  font-weight: 600;
}
